(function(){
  var C = window.__PaisagenVIPCore;
  if (!C) { console.error('Paisagen VIP core missing'); return; }
  var subscribe = C.subscribe, getState = C.getState, turnOn = C.turnOn, turnOff = C.turnOff, addStandard = C.addStandard, openCartDrawer = C.openCartDrawer, convertAndFormat = C.convertAndFormat, fmtCents = C.fmtCents, parseJsonAttr = C.parseJsonAttr;
  var MEMBERSHIP_USD = C.MEMBERSHIP_USD, FREE_SHIP_THRESHOLD_USD = C.FREE_SHIP_THRESHOLD_USD, NECKLACE_USD = C.NECKLACE_USD;

  function initSticky(){
    var wrap = document.getElementById('pgSticky');
    if (!wrap) return;
    if (wrap.dataset.paisagenStickyInit) return;
    wrap.dataset.paisagenStickyInit = 'true';

    var bar = document.getElementById('pgStickyBar');
    var toggle = document.getElementById('pgsToggle');
    var priceEl = document.getElementById('pgsPrice');
    var chargeEl = document.getElementById('pgsToggleCharge');
    var shipEl = wrap.querySelector('.pgs-ship');
    var addBtn = document.getElementById('pgsAddBtn');
    var addBtnText = document.getElementById('pgsAddBtnText');
    if (!toggle || !bar || !addBtn) return;

    var MONEY_FMT = wrap.getAttribute('data-money-format') || '${{amount}}';
    var VARIANTS  = parseJsonAttr(wrap, 'data-variants') || [];
    var localOn = false;
    var isAdding = false;

    function getVariantPrice(){
      try { var v = VARIANTS.find(function(x){ return String(x.id)===String(wrap.dataset.variantId); }); return v ? v.price : 0; } catch(e) { return 0; }
    }

    function render(isOn){
      localOn = isOn;
      toggle.classList.toggle('is-on', isOn);
      toggle.setAttribute('aria-checked', String(isOn));
      bar.classList.toggle('pgs-gold', isOn);
      var price = getVariantPrice();
      var necklaceF = convertAndFormat(NECKLACE_USD);
      if (priceEl) priceEl.innerHTML = isOn ? '<s>'+fmtCents(price, MONEY_FMT)+'</s> '+fmtCents(Math.round(price*0.20), MONEY_FMT) : fmtCents(price, MONEY_FMT);
      if (chargeEl) chargeEl.textContent = isOn ? 'Charged '+convertAndFormat(MEMBERSHIP_USD)+'/mo' : 'Then '+convertAndFormat(MEMBERSHIP_USD)+'/mo';
      if (shipEl) shipEl.textContent = 'Free ' + necklaceF + ' Necklace + Free Ship';
      if (!isAdding) { addBtnText.textContent = isOn ? 'Add to Cart - VIP Price' : 'Add to Cart - Full Price'; addBtn.classList.remove('pgs-add-error'); }
    }

    subscribe(function(s){ if (s.cart) render(s.inCart); });

    toggle.addEventListener('click', function(){
      if (toggle.disabled || isAdding) return;
      toggle.disabled = true;
      var goingOn = !localOn;
      var variantId = Number(wrap.dataset.variantId) || null;
      var task = goingOn ? turnOn(variantId) : turnOff();
      task.finally(function(){ toggle.disabled = false; });
    });

    addBtn.addEventListener('click', function(){
      if (addBtn.disabled) return;
      var variantId = Number(wrap.dataset.variantId);
      if (!variantId) return;
      isAdding = true; addBtn.disabled = true;
      addBtnText.textContent = localOn ? 'Adding VIP...' : 'Adding...';
      var task = localOn ? turnOn(variantId) : addStandard(variantId);
      task.then(function(){
        addBtnText.textContent = 'Added';
        setTimeout(function(){ isAdding=false; addBtn.disabled=false; openCartDrawer(); }, 700);
      }).catch(function(){
        addBtn.classList.add('pgs-add-error');
        addBtnText.textContent = 'Try again';
        setTimeout(function(){ isAdding=false; addBtn.disabled=false; render(localOn); }, 1800);
      });
    });

    function isOverlayOpen(){
      return !!document.querySelector('details[open],dialog[open],.drawer--active,.drawer.is-open,cart-drawer[open],cart-drawer.active');
    }
    function syncOverlay(){ wrap.classList.toggle('pgs-hidden', isOverlayOpen()); }
    window.addEventListener('resize', syncOverlay);
    document.addEventListener('click',function(){ setTimeout(syncOverlay,20); });
    new MutationObserver(syncOverlay).observe(document.documentElement,{attributes:true,childList:true,subtree:true,attributeFilter:['class','open']});
    syncOverlay();
  }

  function initPopup(){
    var overlay = document.getElementById('pgpOverlay');
    if (!overlay) return;
    if (overlay.dataset.paisagenPopupInit) return;
    overlay.dataset.paisagenPopupInit = 'true';

    var modal   = document.getElementById('pgpModal');
    var closeBtn= document.getElementById('pgpClose');
    var contBtn = document.getElementById('pgpContinue');
    var contBtnText = document.getElementById('pgpContinueText');
    var toggle  = document.getElementById('pgpToggle');
    var toggleLabel = document.getElementById('pgpToggleLabel');
    var headline= document.getElementById('pgpHeadline');
    var subEl = overlay.querySelector('.pgp-sub');
    var priceEl = document.getElementById('pgpPrice');
    var priceWasEl = document.getElementById('pgpPriceWas');
    if (!toggle || !modal) return;

    var SEEN_KEY = 'pgp_popup_seen_v1';
    var MONEY_FMT = modal.getAttribute('data-money-format') || '${{amount}}';
    var VARIANTS = parseJsonAttr(modal, 'data-variants') || [];
    var localOn = false;
    var isAdding = false;
    var addedViaToggle = false;

    var discEl = document.getElementById('pgpDiscAmt');
    if (discEl) discEl.textContent = convertAndFormat(MEMBERSHIP_USD);

    function getVariantId(){
      try {
        var form = document.querySelector('form[action*="/cart/add"]');
        var inp = form ? form.querySelector('[name="id"]') : null;
        return inp ? Number(inp.value) : null;
      } catch(e) { return null; }
    }

    function getVariantPrice(){
      try {
        var vid = getVariantId();
        if (!vid) return null;
        var v = VARIANTS.find(function(x){ return String(x.id)===String(vid); }) || VARIANTS[0];
        return v ? v.price : null;
      } catch(e) { return null; }
    }

    function cartHasItems(){
      var s = getState();
      return !!(s.cart && s.cart.item_count > 0);
    }

    function render(isOn){
      localOn = isOn;
      toggle.classList.toggle('is-on', isOn);
      toggle.setAttribute('aria-checked', String(isOn));
      modal.classList.toggle('pgp-gold', isOn);
      if (toggleLabel) toggleLabel.textContent = isOn ? 'On' : 'Off';
      if (headline) headline.textContent = isOn ? '80% off is on' : 'Turn on 80% off';
      var necklaceF = convertAndFormat(C.NECKLACE_USD);
      if (subEl) subEl.textContent = isOn ? 'Free ' + necklaceF + ' necklace · free worldwide shipping' : 'Free ' + necklaceF + ' necklace · free shipping over ' + convertAndFormat(C.FREE_SHIP_THRESHOLD_USD);
      var price = getVariantPrice();
      if (price === null) {
        if (priceEl) priceEl.textContent = 'Free ' + necklaceF + ' Necklace';
        if (priceWasEl) priceWasEl.classList.remove('show');
      } else {
        if (priceEl) priceEl.textContent = isOn ? fmtCents(Math.round(price*0.20), MONEY_FMT) : fmtCents(price, MONEY_FMT);
        if (priceWasEl) { priceWasEl.textContent = fmtCents(price, MONEY_FMT); priceWasEl.classList.toggle('show', isOn); }
      }
      if (!isAdding && contBtnText) contBtnText.textContent = isOn ? 'Continue - VIP Price' : 'Continue';
    }

    subscribe(function(s){ if (s.cart) render(s.inCart); });

    toggle.addEventListener('click', function(){
      if (toggle.disabled || isAdding) return;
      var goingOn = !localOn;
      var variantId = getVariantId();
      toggle.disabled = true;
      var task = goingOn ? turnOn(variantId) : turnOff();
      task.then(function(){
        addedViaToggle = goingOn;
        render(goingOn);
      }).catch(function(){}).finally(function(){ toggle.disabled = false; });
    });

    function openPop(){ overlay.classList.add('open'); document.body.style.overflow='hidden'; render(getState().inCart); }
    function closePop(){ overlay.classList.remove('open'); document.body.style.overflow=''; try{ sessionStorage.setItem(SEEN_KEY,'1'); }catch(e){} }

    function maybeShow(){
      try{ if(sessionStorage.getItem(SEEN_KEY)) return; }catch(e){}
      setTimeout(openPop, 1200);
    }
    var isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    if(!isMobile){
      document.addEventListener('mouseleave', function(e){ if(e.clientY <= 0) maybeShow(); });
    } else {
      var lastY = window.scrollY, upCount = 0;
      window.addEventListener('scroll', function(){
        var cur = window.scrollY;
        if(cur < lastY){ upCount++; if(upCount>=3 && cur<lastY-60) maybeShow(); } else { upCount=0; }
        lastY = cur;
      },{passive:true});
    }

    if (closeBtn) closeBtn.addEventListener('click', closePop);
    overlay.addEventListener('click', function(e){ if(e.target===overlay) closePop(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closePop(); });

    if (contBtn) contBtn.addEventListener('click', function(){
      if (contBtn.disabled) return;
      if (cartHasItems() || addedViaToggle) {
        closePop();
        window.location.href = '/checkout';
        return;
      }
      var variantId = getVariantId();
      if (!variantId) { closePop(); window.location.href='/checkout'; return; }
      isAdding = true; contBtn.disabled = true;
      contBtnText.textContent = 'Adding...';
      var task = localOn ? turnOn(variantId) : addStandard(variantId);
      task.then(function(){
        isAdding=false; contBtn.disabled=false;
        closePop();
        window.location.href='/checkout';
      }).catch(function(){
        isAdding=false; contBtn.disabled=false; contBtnText.textContent='Try again';
      });
    });
  }

  window.PaisagenVIP = window.PaisagenVIP || {};
  Object.assign(window.PaisagenVIP, C, { initSticky: initSticky, initPopup: initPopup });
})();
